import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallHighlightLabel = ({
  label,
  value
}) => {
  if (!value) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "text-left p-left-6",
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: label
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "m-left-1",
      children: value
    })]
  });
};
export default CallHighlightLabel;